export type ReportType = 'radio' | 'publicacion' | 'comentario' | 'mensaje' | 'video' | 'live';

export type ReportStatus = 'pendiente' | 'resuelto' | 'descartado' | 'contenido_oculto' | 'radio_suspendida' | 'usuario_baneado';

export type ReportFilterKey = 'pendientes' | 'resueltos' | 'descartados' | 'criticos';

export const reportFilterKeys: ReportFilterKey[] = ['pendientes', 'resueltos', 'descartados', 'criticos'];

export interface AbuseReport {
  id: number;
  type: ReportType;
  radioName: string;
  radioSlug: string;
  userName: string;
  userEmail: string;
  reason: string;
  description: string;
  evidenceUrl: string | null;
  evidenceDescription: string | null;
  status: ReportStatus;
  critical: boolean;
  createdAt: string;
  reviewedAt: string | null;
  reviewedBy: string | null;
  contentPreview: string;
  contentUrl: string | null;
}

export const reportTypeConfig: Record<ReportType, { label: string; icon: string }> = {
  radio: { label: 'Radio', icon: 'ri-radio-line' },
  publicacion: { label: 'Publicación', icon: 'ri-file-text-line' },
  comentario: { label: 'Comentario', icon: 'ri-chat-1-line' },
  mensaje: { label: 'Mensaje', icon: 'ri-message-2-line' },
  video: { label: 'Video', icon: 'ri-video-line' },
  live: { label: 'Live', icon: 'ri-live-line' },
};

export const reportStatusConfig: Record<ReportStatus, { label: string; dot: string; bg: string; text: string }> = {
  pendiente: { label: 'Pendiente', dot: 'bg-amber-500', bg: 'bg-amber-50', text: 'text-amber-700' },
  resuelto: { label: 'Resuelto', dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700' },
  descartado: { label: 'Descartado', dot: 'bg-foreground-400', bg: 'bg-background-100', text: 'text-foreground-500' },
  contenido_oculto: { label: 'Contenido Oculto', dot: 'bg-sky-500', bg: 'bg-sky-50', text: 'text-sky-700' },
  radio_suspendida: { label: 'Radio Suspendida', dot: 'bg-red-500', bg: 'bg-red-50', text: 'text-red-600' },
  usuario_baneado: { label: 'Usuario Baneado', dot: 'bg-red-600', bg: 'bg-red-50', text: 'text-red-700' },
};

export const reportReasons: string[] = [
  'Spam o publicidad no deseada',
  'Contenido ofensivo o inapropiado',
  'Lenguaje de odio o discriminación',
  'Acoso o intimidación',
  'Información falsa o engañosa',
  'Violación de derechos de autor',
  'Suplantación de identidad',
  'Contenido sexual explícito',
  'Violencia o contenido gráfico',
  'Otro motivo',
];

export const abuseReports: AbuseReport[] = [
  {
    id: 1,
    type: 'radio',
    radioName: 'Radio Pirata FM',
    radioSlug: 'radio-pirata-fm',
    userName: 'maria_garcia',
    userEmail: 'maria.garcia@gmail.com',
    reason: 'Contenido ofensivo o inapropiado',
    description: 'Esta radio transmite contenido con lenguaje extremadamente ofensivo durante el horario familiar. En el programa de las 3 PM del 5 de junio, el locutor usó insultos y comentarios denigrantes hacia minorías.',
    evidenceUrl: 'https://readdy.ai/api/search-image?query=dark%20blurred%20screenshot%20of%20radio%20interface%20with%20offensive%20content%20warning%2C%20red%20and%20gray%20tones%2C%20censored%20text%20areas%2C%20low%20contrast%20editorial%20style%20with%20dark%20overlay%20and%20subtle%20grain%20texture%2C%20mysterious%20atmosphere%2C%20minimal%20composition%20with%20negative%20space&width=1200&height=800&seq=report-evidence-1&orientation=landscape',
    evidenceDescription: 'Captura del stream con timestamp del momento de la ofensa',
    status: 'pendiente',
    critical: true,
    createdAt: '2026-06-08T14:22:00',
    reviewedAt: null,
    reviewedBy: null,
    contentPreview: 'Radio Pirata FM — 88.70 RFW — Programa "La Hora Pesada"',
    contentUrl: '/radio/radio-pirata-fm',
  },
  {
    id: 2,
    type: 'publicacion',
    radioName: 'Radio Urbana 101',
    radioSlug: 'radio-urbana-101',
    userName: 'carlos_mendoza',
    userEmail: 'carlos.mendoza@hotmail.com',
    reason: 'Spam o publicidad no deseada',
    description: 'La publicación del 7 de junio contiene enlaces de afiliados no declarados y promociona un servicio de dudosa reputación. Además el post tiene múltiples comentarios falsos generados por bots para inflar su alcance.',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'resuelto',
    critical: false,
    createdAt: '2026-06-07T16:42:00',
    reviewedAt: '2026-06-08T10:15:00',
    reviewedBy: 'superadmin@rfw.com',
    contentPreview: '"🔥 GANA DINERO FÁCIL desde casa sin inversión. Miles ya lo hicieron. Click aquí 👉 enlace-sospechoso.com"',
    contentUrl: '/radio/radio-urbana-101',
  },
  {
    id: 3,
    type: 'comentario',
    radioName: 'Radio Fiesta Mix',
    radioSlug: 'radio-fiesta-mix',
    userName: 'laura_velez',
    userEmail: 'laura.velez@gmail.com',
    reason: 'Acoso o intimidación',
    description: 'Un usuario en la sección de comunidad ha estado acosando a oyentes con comentarios agresivos y amenazas veladas. El comentario fue hecho en el post "Nueva programación de verano" del 6 de junio.',
    evidenceUrl: 'https://readdy.ai/api/search-image?query=blurred%20screenshot%20of%20social%20media%20comment%20section%20with%20redacted%20harassing%20messages%2C%20dark%20moody%20interface%2C%20warning%20icons%2C%20muted%20red%20and%20charcoal%20palette%2C%20content%20moderation%20visual%20style%2C%20soft%20shadows%20and%20clean%20layout%20with%20mysterious%20atmosphere&width=1200&height=800&seq=report-evidence-2&orientation=landscape',
    evidenceDescription: 'Captura de pantalla del comentario y perfil del usuario',
    status: 'pendiente',
    critical: true,
    createdAt: '2026-06-08T10:08:00',
    reviewedAt: null,
    reviewedBy: null,
    contentPreview: 'Comentario de @usuario_toxico: "Mejor cierra esa radio ridícula, nadie te escucha..."',
    contentUrl: '/radio/radio-fiesta-mix',
  },
  {
    id: 4,
    type: 'mensaje',
    radioName: 'Radio Retro Vibes',
    radioSlug: 'radio-retro-vibes',
    userName: 'ana_perez',
    userEmail: 'ana.perez@yahoo.com',
    reason: 'Lenguaje de odio o discriminación',
    description: 'Durante el chat en vivo del programa nocturno del 5 de junio, un usuario envió múltiples mensajes con lenguaje discriminatorio hacia la comunidad LGBTQ+. Los mensajes fueron vistos por al menos 50 oyentes activos.',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'pendiente',
    critical: true,
    createdAt: '2026-06-08T08:30:00',
    reviewedAt: null,
    reviewedBy: null,
    contentPreview: 'Chat en vivo — "Noches Retro" — Mensaje de @user_agresivo con lenguaje discriminatorio',
    contentUrl: '/radio/radio-retro-vibes',
  },
  {
    id: 5,
    type: 'video',
    radioName: 'Radio Éxitos TV',
    radioSlug: 'radio-exitos-tv',
    userName: 'diego_rojas',
    userEmail: 'diego.rojas@outlook.com',
    reason: 'Violación de derechos de autor',
    description: 'El video "Concierto Tributo a los 80\'s" publicado el 4 de junio contiene material con copyright de Sony Music sin autorización. Se usan al menos 4 canciones completas sin licencia ni atribución.',
    evidenceUrl: 'https://readdy.ai/api/search-image?query=screenshot%20of%20video%20player%20showing%20copyrighted%20concert%20footage%20with%20watermark%2C%20legal%20notice%20overlay%2C%20dark%20theater%20setting%2C%20warm%20amber%20stage%20lights%2C%20blurred%20performers%2C%20copyright%20infringement%20visual%2C%20editorial%20style%20with%20warning%20icons&width=1200&height=800&seq=report-evidence-3&orientation=landscape',
    evidenceDescription: 'Timestamp del video y comparación con material original',
    status: 'resuelto',
    critical: false,
    createdAt: '2026-06-07T14:20:00',
    reviewedAt: '2026-06-08T09:00:00',
    reviewedBy: 'superadmin@rfw.com',
    contentPreview: 'Video "Concierto Tributo a los 80\'s" — 24:18 — 4 canciones con copyright',
    contentUrl: '/radio/radio-exitos-tv',
  },
  {
    id: 6,
    type: 'live',
    radioName: 'Radio Nueva Actitud',
    radioSlug: 'radio-nueva-actitud',
    userName: 'jorge_campos',
    userEmail: 'jorge.campos@gmail.com',
    reason: 'Contenido sexual explícito',
    description: 'Durante el live "Tardes de Pop" del 6 de junio a las 5 PM, el presentador mostró contenido inapropiado en cámara durante aproximadamente 2 minutos. Había unos 300 espectadores en ese momento.',
    evidenceUrl: 'https://readdy.ai/api/search-image?query=heavily%20blurred%20censored%20screenshot%20of%20live%20stream%20with%20content%20warning%20banner%2C%20dark%20gray%20and%20warm%20red%20color%20scheme%2C%20pixelated%20areas%2C%20emergency%20broadcast%20style%2C%20minimal%20composition%2C%20studio%20setting%20with%20dim%20lighting%20and%20warning%20symbols&width=1200&height=800&seq=report-evidence-4&orientation=landscape',
    evidenceDescription: 'Captura del live en el momento exacto del incidente',
    status: 'pendiente',
    critical: true,
    createdAt: '2026-06-07T11:15:00',
    reviewedAt: null,
    reviewedBy: null,
    contentPreview: 'Live "Tardes de Pop" — 5:23 PM — 312 espectadores — Radio Nueva Actitud',
    contentUrl: '/radio/radio-nueva-actitud',
  },
  {
    id: 7,
    type: 'radio',
    radioName: 'Radio Sonora Digital',
    radioSlug: 'radio-sonora-digital',
    userName: 'patricia_luna',
    userEmail: 'patricia.luna@gmail.com',
    reason: 'Información falsa o engañosa',
    description: 'La radio difunde repetidamente información de salud sin fundamento científico. En el programa matutino del 3 de junio promocionaron "curas milagrosas" para enfermedades crónicas sin respaldo médico.',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'descartado',
    critical: false,
    createdAt: '2026-06-06T09:30:00',
    reviewedAt: '2026-06-07T16:45:00',
    reviewedBy: 'superadmin@rfw.com',
    contentPreview: 'Radio Sonora Digital — 97.30 RFW — "Salud y Bienestar" — Promoción de curas no verificadas',
    contentUrl: '/radio/radio-sonora-digital',
  },
  {
    id: 8,
    type: 'comentario',
    radioName: 'Clásicos del Rock',
    radioSlug: 'clasicos-del-rock',
    userName: 'andres_medina',
    userEmail: 'andres.medina@hotmail.com',
    reason: 'Spam o publicidad no deseada',
    description: 'Varios comentarios en la sección de fotos contienen spam con enlaces a sitios de apuestas. El usuario publicó el mismo mensaje en al menos 5 fotos diferentes.',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'contenido_oculto',
    critical: false,
    createdAt: '2026-06-05T18:40:00',
    reviewedAt: '2026-06-06T11:20:00',
    reviewedBy: 'superadmin@rfw.com',
    contentPreview: 'Comentario spam con enlace: "Gana dinero en casinos online 🎰👉 apuesta-ya.com" x5 repeticiones',
    contentUrl: '/radio/clasicos-del-rock',
  },
  {
    id: 9,
    type: 'publicacion',
    radioName: 'Radio Pirata FM',
    radioSlug: 'radio-pirata-fm',
    userName: 'lucia_torres',
    userEmail: 'lucia.torres@gmail.com',
    reason: 'Violencia o contenido gráfico',
    description: 'La publicación del 2 de junio incluye una imagen con contenido violento explícito. La foto muestra una escena gráfica no apta para la audiencia general de la plataforma.',
    evidenceUrl: 'https://readdy.ai/api/search-image?query=severely%20blurred%20and%20censored%20image%20with%20content%20warning%20overlay%2C%20red%20banner%20stating%20removed%20content%2C%20dark%20moody%20atmosphere%2C%20minimal%20design%2C%20warning%20symbols%2C%20platform%20moderation%20visual%2C%20black%20and%20dark%20red%20palette&width=1200&height=800&seq=report-evidence-5&orientation=landscape',
    evidenceDescription: 'Imagen reportada con el contenido explícito',
    status: 'radio_suspendida',
    critical: true,
    createdAt: '2026-06-04T22:10:00',
    reviewedAt: '2026-06-05T08:30:00',
    reviewedBy: 'superadmin@rfw.com',
    contentPreview: 'Publicación con imagen violenta — Radio Pirata FM — 2 de junio',
    contentUrl: '/radio/radio-pirata-fm',
  },
  {
    id: 10,
    type: 'mensaje',
    radioName: 'Radio Urbana 101',
    radioSlug: 'radio-urbana-101',
    userName: 'mario_silva',
    userEmail: 'mario.silva@yahoo.com',
    reason: 'Suplantación de identidad',
    description: 'Un usuario en el chat está haciéndose pasar por el locutor oficial de la radio. Está enviando mensajes privados a oyentes pidiendo dinero para supuestas "membresías VIP".',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'usuario_baneado',
    critical: true,
    createdAt: '2026-06-03T15:55:00',
    reviewedAt: '2026-06-04T09:10:00',
    reviewedBy: 'superadmin@rfw.com',
    contentPreview: 'Chat: @ElLocutorOficial (falso) — "Amigo, para ser VIP necesito que deposites $50..."',
    contentUrl: '/radio/radio-urbana-101',
  },
  {
    id: 11,
    type: 'video',
    radioName: 'Radio Stereo Visión',
    radioSlug: 'radio-stereo-vision',
    userName: 'claudia_ramirez',
    userEmail: 'claudia.ramirez@gmail.com',
    reason: 'Contenido ofensivo o inapropiado',
    description: 'El video "Entrevista Callejera" del 1 de junio muestra a personas siendo grabadas sin su consentimiento en situaciones comprometedoras. Viola la privacidad de los transeúntes y contiene burlas.',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'pendiente',
    critical: false,
    createdAt: '2026-06-02T12:45:00',
    reviewedAt: null,
    reviewedBy: null,
    contentPreview: 'Video "Entrevista Callejera" — 8:42 — Personas grabadas sin consentimiento',
    contentUrl: '/radio/radio-stereo-vision',
  },
  {
    id: 12,
    type: 'live',
    radioName: 'Radio Clásica FM',
    radioSlug: 'radio-clasica-fm',
    userName: 'roberto_leon',
    userEmail: 'roberto.leon@outlook.com',
    reason: 'Violación de derechos de autor',
    description: 'El live "Sinfónica en Vivo" del 31 de mayo transmite una presentación completa de la Orquesta Filarmónica sin autorización. El concierto completo dura 2 horas y está protegido por derechos de interpretación.',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'resuelto',
    critical: false,
    createdAt: '2026-06-01T19:20:00',
    reviewedAt: '2026-06-03T14:00:00',
    reviewedBy: 'superadmin@rfw.com',
    contentPreview: 'Live "Sinfónica en Vivo" — 2:04:17 — Orquesta Filarmónica sin licencia',
    contentUrl: '/radio/radio-clasica-fm',
  },
  {
    id: 13,
    type: 'radio',
    radioName: 'Radio TechBeats',
    radioSlug: 'radio-techbeats',
    userName: 'sofia_herrera',
    userEmail: 'sofia.herrera@gmail.com',
    reason: 'Lenguaje de odio o discriminación',
    description: 'En el programa matutino del 7 de junio, el locutor principal realizó comentarios despectivos sobre inmigrantes. La transmisión llegó a más de 500 oyentes en vivo.',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'pendiente',
    critical: true,
    createdAt: '2026-06-09T08:10:00',
    reviewedAt: null,
    reviewedBy: null,
    contentPreview: 'Radio TechBeats — 96.50 RFW — Programa "Wake Up Call" — Comentarios discriminatorios',
    contentUrl: '/radio/radio-techbeats',
  },
  {
    id: 14,
    type: 'publicacion',
    radioName: 'Radio Deportiva Total',
    radioSlug: 'radio-deportiva-total',
    userName: 'raul_vargas',
    userEmail: 'raul.vargas@gmail.com',
    reason: 'Información falsa o engañosa',
    description: 'La publicación sobre resultados deportivos contiene estadísticas fabricadas. Se inventaron marcadores y datos de rendimiento de jugadores.',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'descartado',
    critical: false,
    createdAt: '2026-06-05T14:30:00',
    reviewedAt: '2026-06-06T09:00:00',
    reviewedBy: 'superadmin@rfw.com',
    contentPreview: 'Publicación "Resultados de la jornada" — Estadísticas inventadas — Radio Deportiva Total',
    contentUrl: '/radio/radio-deportiva-total',
  },
  {
    id: 15,
    type: 'comentario',
    radioName: 'Radio Folclor Andino',
    radioSlug: 'radio-folclor-andino',
    userName: 'elena_morales',
    userEmail: 'elena.morales@yahoo.com',
    reason: 'Spam o publicidad no deseada',
    description: 'Comentario promocionando un servicio de streaming pirata con enlaces sospechosos.',
    evidenceUrl: null,
    evidenceDescription: null,
    status: 'pendiente',
    critical: false,
    createdAt: '2026-06-09T06:45:00',
    reviewedAt: null,
    reviewedBy: null,
    contentPreview: 'Comentario spam: "Mira radio GRATIS sin anuncios en 👉 stream-pirata.net"',
    contentUrl: '/radio/radio-folclor-andino',
  },
];